import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=6fe6ff50&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
import style0 from "./Form.vue?vue&type=style&index=0&id=6fe6ff50&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe6ff50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fe6ff50')) {
      api.createRecord('6fe6ff50', component.options)
    } else {
      api.reload('6fe6ff50', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=6fe6ff50&scoped=true", function () {
      api.rerender('6fe6ff50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/lesson/Form.vue"
export default component.exports